import { lazy } from 'react';
import LogIn from '../Authentication/components/LogIn';
import LogOut from '../Authentication/components/LogOut';
import Unauthorized from './views/Unauthorized';

const UserSearch = lazy(() => import("../UserSearch/components/index"));
const UserPool = lazy(() => import("../UserPool/components/index"));
const DevUsers = lazy(() => import("../DevUsers/components/index"));
const ApplicationSearch = lazy(() => import("../ApplicationSearch/components/index"));

const PATHS = [
    {
        path: "/",
        title: "User Search",
        show: process.env.REACT_APP_NAV_USERSEARCH === "true",
        Component: UserSearch,
    },
    {
        path: "/application-search",
        title: "Application Search",
        show: process.env.REACT_APP_NAV_APPSEARCH === "true",
        Component: ApplicationSearch,
    },
    {
        path: "/user-pool",
        title: "User Pool",
        show: process.env.REACT_APP_NAV_USERPOOL === "true",
        Component: UserPool,
    },
    {
        path: "/dev-users",
        title: "Dev Users",
        show: process.env.REACT_APP_NAV_DEVUSERS === "true",
        Component: DevUsers,
    }
].filter(link => link.show);

PATHS[0].path = "/"; // Set the first path to root, in case we disable/remove User Search

export const authorizationRoutes = {
    login: "/login",
    logout: "/logout",
    unauthorized: "/unauthorized",
  };

const authenticationFlowPaths = [
    {
        path: authorizationRoutes.login,
        title: "Log In",
        Component: LogIn 
    },
    {
        path: authorizationRoutes.logout,
        title: "Log Out",
        Component: LogOut 
    },
    {
        path: authorizationRoutes.unauthorized,
        title: "Not authorized",
        Component: Unauthorized 
    }
]

export {
    authenticationFlowPaths,
    PATHS as default
}